export default __webpack_public_path__ + "static/media/LeftQuotes.6314367f.svg";